import React from 'react';
import LegalPage from '../../components/templates/page/legal';
import { jsx as ___EmotionJSX } from "@emotion/react";
const LegalPageTemplate = props => ___EmotionJSX(LegalPage, props);
const query = "639845530";
export default LegalPageTemplate;